<template>
  <div class="donation-form">
    <fieldset>
      <div class="row">
        <div class="column column-100">
          <CountrySwitcher/>
        </div>
      </div>
      <SumSelector/>
      <div class="row">
        <div class="column column-100">
          <MonthSwitcher/>
        </div>
      </div>
      <div class="row">
        <div class="column column-100">
          <MethodSwitcher/>
        </div>
      </div>
      <div v-if="!isLinkMethod()">
        <div class="row">
          <div class="column column-100">
            <Email/>
          </div>
        </div>
        <div class="row">
          <div class="column column-100">
            <input type="text" name="firstname" @input="updateValue" :placeholder="labels['name']" :value="firstname">
          </div>
        </div>
        <div class="row">
          <div class="column">
            <Agreement/>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <button class="button button-outline donate" @click="donate">{{ action }}</button>
          </div>
        </div>
        <div class="external-footer">
          <div class="row">
            <div class="column column-100">
              <p>Советуем отключить VPN перед оплатой.</p>
              <p>Если вы находитесь в России, <a href="https://c.cloudpayments.ru/payments/3be9763ff4f84179864b6d347c890e80">воспользуйтесь этой формой</a> для российских карт — она работает без VPN.</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="row">
          <div class="column method-description">
            {{ labels[activeMethod + '-description'] }}
          </div>
        </div>
        <div class="row">
          <div class="column">
            <a class="button button-outline donate" :href="methods[activeMethod].url" target="_blank">{{ labels[activeMethod + '-label'] }}</a>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SumSelector from './SumSelector.vue'
import CountrySwitcher from './CountrySwitcher.vue'
import MethodSwitcher from './MethodSwitcher.vue'
import MonthSwitcher from './MonthSwitcher.vue'
import Email from './Email.vue'
import Agreement from './Agreement.vue'
import { LABELS, VALIDATION_MESSAGES } from '@/settings'

export default {
  components: { Agreement, CountrySwitcher, Email, MethodSwitcher, MonthSwitcher, SumSelector },
  computed: mapState({
    firstname: state => state.donation.firstname,
    email: state => state.donation.email,
    month: state => state.donation.month,
    terms: state => state.terms,
    lang: state => state.language,
    labels: state => LABELS[state.language],
    action: state => LABELS[state.language][state.donation.month ? 'subscribe' : 'donate'],
    activeMethod: state => state.donation.method,
    methods: state => state.operators,
    sum: state => state.donation.sum
  }),
  methods: {
    isLinkMethod () {
      return !!this.methods[this.activeMethod].url
    },
    updateValue (e) {
      const prop = e.target.name
      const value = e.target.value
      const change = { prop, value }
      this.$store.commit('updateDonation', change)
    },
    donate () {
      if (!this.sum) {
        return
      }
      // TODO missing validation scope, returns true even when has errors
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$store.dispatch('donate')
        }
      })
    }
  },
  mounted () {
    const lang = this.lang
    this.$validator.localize(lang, VALIDATION_MESSAGES[lang])
  }
}
</script>

<style scoped>
  .oi-donation-form fieldset,
  .oi-donation-form input,
  .oi-donation-form select,
  .oi-donation-form textarea {
    margin-bottom: 10px;
  }
  .oi-donation-form .method-description {
    margin-bottom: 10px!important;
  }
  .oi-donation-form .external-footer {
    font-size: 12px;
    padding-bottom: 10px;
  }
</style>
